var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9C7.83579 9 7.5 9.33579 7.5 9.75V14.25C7.5 14.6642 7.83579 15 8.25 15H12.75C13.1642 15 13.5 14.6642 13.5 14.25V9.75C13.5 9.33579 13.1642 9 12.75 9H8.25ZM9 13.5V10.5H12V13.5H9Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75C2 5.12665 4.12665 3 6.75 3H17.2501C19.8734 3 22.0001 5.12665 22.0001 7.75C22.0001 8.98811 21.5256 10.1164 20.7501 10.9613V18.75C20.7501 19.9926 19.7427 21 18.5001 21H5.5C4.25736 21 3.25 19.9926 3.25 18.75V10.9613C2.47451 10.1164 2 8.98811 2 7.75ZM6.75 4.5C4.95507 4.5 3.5 5.95507 3.5 7.75C3.5 8.67951 3.88924 9.51689 4.51572 10.1102C4.66528 10.2518 4.75 10.4488 4.75 10.6548V18.75C4.75 19.1642 5.08579 19.5 5.5 19.5H15.5C15.9142 19.5 16.25 19.1642 16.25 18.75V11.0577C16.25 10.8096 16.3726 10.5776 16.5776 10.4379C17.4378 9.85165 18 8.86637 18 7.75C18 5.95507 16.5449 4.5 14.75 4.5H6.75Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFood);
export default __webpack_public_path__ + "static/media/filter-food.6e7f297c2ac2e0ab4f604b5cd885978e.svg";
export { ForwardRef as ReactComponent };